<template>
  <section class="resume-section" id="education">
    <div class="resume-section-content">
      <h2 class="mb-5">Education</h2>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">Florida Polytechnic University</h3>
          <div class="subheading mb-0">Masters of Engineering - Inaugural Class</div>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">Graduated 2015</span></div>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">University of California Irvine</h3>
          <div class="subheading mb-3">Certificate in Embedded Systems Engineering</div>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">Graduated 2014</span></div>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">UMASS Lowell</h3>
          <div class="subheading mb-0">Bachelors in Electrical Engineer</div>
          <div class="subheading mb-0">Minor in Audio Recording</div>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">Graduated 2012</span></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
name: "Education"
}
</script>

<style scoped>
h2 {
  text-transform: uppercase;
}

h3 {
  font-weight: 600;
  text-transform: uppercase;
}

</style>